module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Shaders_outline_fragment__;